import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { GroupsService } from '@app/services/settings/groups.service';
import { Subscription } from 'rxjs';

import { Group } from '@core/objects/group';

@Component({
    selector: 'settings-groups-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss']
})
export class SettingsGroupsListComponent implements OnInit, OnDestroy{

	public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;

	@Output() select = new EventEmitter<Group>();

	public status: Number = 0;
    public subscriptionGroups: Subscription;
    

	public groups: Array<Group> = [];

	constructor(public grpSrv: GroupsService){}

	ngOnInit(){
			this.grpSrv.loadAllGroups();

			this.subscriptionGroups = this.grpSrv.selectorGetAllGroups().subscribe((groups: Group[]) => {
			this.groups = groups;
			if(groups !== null) {
				this.status = this.STATUS_DONE;
				// this.loadInactiveGroups();
			}
				
			// this.userSrv.loadAllLicenses();
        });
	}

	ngOnDestroy(): void {
		this.subscriptionGroups.unsubscribe();
		this.grpSrv.clear(); // clear groups when leaving solve some issues showing wrong groups
	}

	// loadInactiveGroups() {
	// 	this.grpSrv.findInactiveGroups().subscribe((groups: Group[]) => this.groups.push(...groups));
	// }

	onSelect(group: Group) {
		if(group.active)
			this.select.emit(group);
	}

	manageActivation(group: Group) {
		// console.log("grooupp-->", group)
		if(group.active)
			this.grpSrv.deleteGroup(group);
		else
			this.grpSrv.activeGroup(group);
	}
}
